import React from 'react';
import PropTypes from 'prop-types';

class CheckoutMessage extends React.Component {
    componentDidMount = () => {
        const offset = (this.component.getBoundingClientRect().top + window.scrollY) - 25;

        window.scrollTo(0, offset);
    };

    render = () => (
        <div className="checkout-message" ref={(c) => { this.component = c; }}>
            {this.props.children}
        </div>
    );
}

CheckoutMessage.propTypes = {
    children: PropTypes.node.isRequired,
};

export default CheckoutMessage;



// WEBPACK FOOTER //
// ./resources/components/shop/components/CheckoutMessage.jsx